import { render } from "./xjedit.vue?vue&type=template&id=3981df87&scoped=true"
import script from "./xjedit.vue?vue&type=script&lang=js"
export * from "./xjedit.vue?vue&type=script&lang=js"

import "./xjedit.vue?vue&type=style&index=0&id=3981df87&lang=scss&scoped=true"
import "./xjedit.vue?vue&type=style&index=1&id=3981df87&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3981df87"]])

export default __exports__